import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { longDay } from "@/lib/tina/festival-page";
import type {
  PageForm,
  PageFormAction,
} from "@/pages/tina/festivals/lib/page-form";
import type { FestivalPageRead } from "@/types/tina-festival-page";

interface RemovedDaysProps {
  form: PageForm;
  dispatch: (action: PageFormAction) => void;
  page: FestivalPageRead;
}

/** The stored days the curator took off an approved page: they leave when the changes are published, or come back. */
export function RemovedDays({ form, dispatch, page }: RemovedDaysProps) {
  const entries = Object.entries(form.removed);
  if (entries.length === 0) return null;
  return (
    <ul className="flex flex-col gap-2">
      {entries.map(([stored, removed]) => {
        const number = page.days.find((d) => d.day === stored)?.day_number;
        return (
          <li
            key={stored}
            className="flex flex-col gap-1 rounded-md border border-dashed p-3 text-sm"
          >
            <p>
              Day {number ?? "?"} ({longDay(stored).replace(/^\w+ /, "")})
              leaves the festival when you publish.
            </p>
            <label className="flex items-center gap-2">
              <Checkbox
                checked={removed.deleteInMood}
                onCheckedChange={(checked) =>
                  dispatch({
                    type: "set_delete_in_mood",
                    loadedDay: stored,
                    on: checked === true,
                  })
                }
              />
              Also delete its event in Mood (only if nobody saved it)
            </label>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="self-start"
              onClick={() =>
                dispatch({ type: "restore_day", loadedDay: stored })
              }
            >
              Undo
            </Button>
          </li>
        );
      })}
    </ul>
  );
}
